module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/FT038-d8b1188dcb6efe6a3bfe5d20c57e9f82.png";